<template>
  <div class="app-main">
    <transition
      name="fade-r2l"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'LayoutMain',
  components: {},
  data () {
    return {
      tabs: [],
    }
  },
}
</script>
<style>
.app-main {
  position: absolute;
  left: 200px;
  width: calc(100% - 200px);
  height: calc(100% - 100px);
  overflow: hidden;
  background-color: rgb(28, 37, 80);
}

.app-container {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  background-color: rgb(28, 37, 80);
}

.app-content{
  width: 100% !important;
  height: 100% !important;
  box-sizing: border-box;
  overflow: auto;
}
</style>
